import { ResultStat, Warning, WarningLevel } from '../types';

const warningMessages = {
  0: 'warnings.insufficentYeastGrowth',
  1: 'warnings.sluggishFermentation',
  2: 'warnings.mightGetStuckSoon',
  3: 'warnings.viabilityCantBeDetermined',
  4: 'warnings.yeastDecliningTooQuickly',
};

const warningLevels = {
  0: WarningLevel.Info,
  1: WarningLevel.Warning,
};

const createWarning = (warning: any): Warning | null => {
  const isWarningExsits = typeof warning?.msg_type === 'number';

  if (!isWarningExsits) return null;

  return {
    level: warningLevels[warning?.msg_type as 0 | 1],
    message: warningMessages[warning.msg_id as 0 | 1 | 2 | 3 | 4],
  };
};

export const createResultStat = (res: any): ResultStat => {
  const { fw_viab_warning, fw_conz_warning, fw_density_warning, ...rest } = res;

  return {
    ...rest,
    viabilityWarning: createWarning(fw_viab_warning),
    densityWarning: createWarning(fw_density_warning),
    concentrationWarning: createWarning(fw_conz_warning),
  };
};
